"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validPropFunction = validPropFunction;
exports.validPropFunctionOld = validPropFunctionOld;
const defineSchema_1 = require("./defineSchema");
const fix_parent_1 = require("./fix$parent");
const funcParams_1 = require("./funcParams");
function validPropFunction(rule
/* cache: boolean = true */
) {
    if ((0, defineSchema_1.isFunction)(rule))
        return rule;
    let s = '';
    if (typeof rule === 'string') {
        rule = (0, fix_parent_1.fix$parent)(rule);
        s = `return (${rule})`;
    }
    else if (Array.isArray(rule)) {
        for (const item of rule) {
            if (typeof item === 'string') {
                s += (0, fix_parent_1.fix$parent)(item) + '\r\n';
            }
            else {
                let ss = item.when || item.if || 'true';
                ss = (0, fix_parent_1.fix$parent)(ss);
                let ss2 = item.value;
                if (ss2 === undefined) {
                    ss2 = ss;
                }
                else {
                    if (typeof ss2 === 'string') {
                        ss2 = (0, fix_parent_1.fix$parent)(ss2);
                    }
                }
                if (ss2.indexOf('$result') > -1) {
                    s += `if (${ss}) {${ss2}};\r\n`;
                    // s = `var $result=null;\r\n${s}\r\nreturn $result;`;
                }
                else if (ss2.indexOf('return ') == -1) {
                    s += `if (${ss}) return (${ss2});\r\n`;
                }
                else {
                    s += `if (${ss}) {${ss2}};\r\n`;
                }
            }
        }
        // s = 'var $result=null;\r\n' + s + 'return $result;';
    }
    if (s.indexOf('$value') > -1) {
        s = `var $value=$obj.$model;\r\n${s}`;
    }
    if (s.indexOf('$result') > -1) {
        s = `var $result=null;\r\n${s}\r\nreturn $result;`;
    }
    else if (s.indexOf('return ') == -1) {
        s = `return (${s})`;
    }
    // console.log('create valid function', rule, s);
    return new Function('{' + funcParams_1.funcParams + '}', s);
}
function validPropFunctionOld(rule /*, cache: boolean = true */) {
    let s = '';
    if (typeof rule === 'string') {
        rule = (0, fix_parent_1.fix$parent)(rule);
        s = `return (${rule})`;
    }
    else if (Array.isArray(rule)) {
        for (const item of rule) {
            if (typeof item === 'string') {
                s += (0, fix_parent_1.fix$parent)(item) + '\r\n';
            }
            else {
                let ss = item.when || item.if || 'true';
                ss = (0, fix_parent_1.fix$parent)(ss);
                let ss2 = item.value;
                if (ss2 === undefined) {
                    ss2 = ss;
                }
                else {
                    if (typeof ss2 === 'string') {
                        ss2 = (0, fix_parent_1.fix$parent)(ss2);
                    }
                }
                s += `if (${ss}) return (${ss2});\r\n`;
            }
        }
        s = 'var $result=null;\r\n' + s + 'return $result;';
    }
    // console.log('create valid function', rule, s);
    return new Function(funcParams_1.funcParams, s);
}
exports.default = validPropFunction;
//# sourceMappingURL=validPropFunction.js.map